"use strict";
exports.__esModule = true;
exports.UPDATE_PORTAL_CREDENTIALS_LOADING = exports.UPDATE_PORTAL_CREDENTIALS_SUCCESS = exports.UPDATE_PORTAL_CREDENTIALS_SUCCESS_MODAL = exports.UPDATE_PORTAL_CREDENTIALS_ERROR_MODAL = void 0;
exports.UPDATE_PORTAL_CREDENTIALS_ERROR_MODAL = {
    INVALID_CREDENTIALS: {
        TITLE: 'Incorrect username and/or password',
        MESSAGE: 'We couldn’t connect to {{portalDisplayName}} with the login information you provided. Please try again.',
        CTA: 'Close'
    },
    NO_ACTIVE_LEASE: {
        TITLE: 'Missing lease information',
        MESSAGE: 'We couldn’t find an active lease associated with your {{portalDisplayName}} account. Contact your property manager to ensure your lease is set up correctly.',
        CTA: 'Close'
    },
    INACTIVE_PORTAL: {
        TITLE: 'Incorrect portal',
        MESSAGE: 'This can happen if your property has changed portal providers or if you have a new property manager.\n\nContact our support team and we’ll make sure the correct portal is assigned to your acount.',
        CTA: 'Close'
    },
    MULTIPLE_ACTIVE_LEASES: {
        TITLE: 'More than one lease is on your {{portalDisplayName}} account',
        MESSAGE: 'Contact our support team and we’ll make sure the right lease is assigned to your account.',
        CTA: 'Contact support'
    },
    TWO_FACTOR_BLOCKED: {
        TITLE: 'Two factor authentication must be off',
        MESSAGE: 'Please disable two factor authentication for your {{portalDisplayName}} account and try again.',
        CTA: 'Go to portal'
    },
    PORTAL_RESET_PASSWORD_REQUIRED: {
        TITLE: 'Password reset required',
        MESSAGE: '{{portalDisplayName}} needs you to reset your password. Once you have a new password, come back to the Flex app to update your portal connection.',
        CTA: 'Reset portal password'
    },
    UNCATEGORIZED_ERROR: {
        TITLE: 'Couldn’t connect to your portal',
        MESSAGE: 'Make sure you’ve entered your {{portalDisplayName}} login information correctly and try again.',
        CTA: 'Close'
    }
};
exports.UPDATE_PORTAL_CREDENTIALS_SUCCESS_MODAL = {
    TITLE: 'Portal login updated',
    MESSAGE: 'You’ve successfully changed your portal login information.',
    CTA: 'Close'
};
exports.UPDATE_PORTAL_CREDENTIALS_SUCCESS = {
    TITLE: 'Connection successful',
    MESSAGE: 'You’re all set!',
    CTA: 'Done'
};
exports.UPDATE_PORTAL_CREDENTIALS_LOADING = {
    MESSAGE: 'Please keep the app open while we connect to your portal',
    DURATION: 'about 30 seconds'
};
